import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import styles from "./TrackerSelectOption.module.scss";
import { User } from "src/assets/icons";
import { getUserFullName } from "src/utils";
import { selectUser, selectCompanyMembers } from "src/store/selectors";
import {
  TrackerStatusIcon,
  TrackerKeywordsDataSourcesIcon,
} from "src/features";

type Props = {
  tracker: Tracker.Data;
};

export const TrackerSelectOption: FC<Props> = ({ tracker }) => {
  const { t } = useTranslation();

  const user = useSelector(selectUser);

  const companyMembers = useSelector(selectCompanyMembers);

  const trackerAuthorName = useMemo<string>(() => {
    const trackerAuthor = companyMembers[tracker.authorId];

    if (!trackerAuthor) return "";

    if (user.id === tracker.authorId)
      return t("component.modal.create_dashboard.label.current_user", {
        name: getUserFullName(user),
      });

    return getUserFullName(trackerAuthor);
  }, [companyMembers, tracker.authorId, user, t]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.nameWrapper}>
        <span>{tracker.name}</span>
        <TrackerKeywordsDataSourcesIcon trackerId={tracker.id} />
        <TrackerStatusIcon trackerId={tracker.id} />
      </div>
      <div className={styles.metadataWrapper}>
        <div className={styles.authorWrapper}>
          <User />
          <span>{trackerAuthorName}</span>
        </div>
      </div>
    </div>
  );
};
